export enum PermissionNumber {
  AcaoPorPessoaDisparar = 1,
  AcessosObterTodos = 2,
  AcoesAdicionar = 3,
  AcoesAdicionarAcoesPessoas = 4,
  AcoesAdicionarCometarios = 5,
  AcoesAtualizar = 6,
  AcoesAtualizarEtapas = 7,
  AcoesDetalhamentosObterTodos = 8,
  AcoesObterDetalhamentoPorId = 9,
  AcoesObterPorId = 10,
  AcoesObterTodos = 11,
  AcoesRemoverPorPessoaId = 12,
  AdicionarAssinaturaPessoaTransferencia = 13,
  AjusteAtualizar = 14,
  AjusteEstoqueProdutoAdicionar = 15,
  AjusteEstoqueProdutoAtualizar = 16,
  AjusteEstoqueProdutoObterPorId = 17,
  AjusteEstoqueProdutoObterTodos = 18,
  AjusteEstoqueProdutoRemover = 19,
  AssinaturaAdicionar = 20,
  AssinaturaAgrupadoraAdicionar = 21,
  AssinaturaAgrupadoraAtualizar = 22,
  AssinaturaAgrupadoraObterPorId = 23,
  AssinaturaAgrupadoraRemover = 24,
  AssinaturaAtualizar = 25,
  AssinaturaHorarioAdicionar = 26,
  AssinaturaHorarioAtualizar = 27,
  AssinaturaHorarioObterPorId = 28,
  AssinaturaHorarioObterTodos = 29,
  AssinaturaHorarioRemover = 30,
  AssinaturaObterPorId = 31,
  AssinaturaObterTodos = 32,
  AssinaturaOcupacaoObterTodos = 33,
  AssinaturaPessoaAdicionar = 34,
  AssinaturaPessoaAdicionarRecesso = 35,
  AssinaturaPessoaAdicionarRecessoColetivo = 36,
  AssinaturaPessoaAdicionarTrancamento = 37,
  AssinaturaPessoaAlterar = 38,
  AssinaturaPessoaAtualizar = 39,
  AssinaturaPessoaEditarRecesso = 40,
  AssinaturaPessoaEditarTrancamento = 41,
  AssinaturaPessoaEncerramentoObterTodos = 42,
  AssinaturaPessoaFrequenciaObterTodos = 43,
  AssinaturaPessoaObterPorId = 44,
  AssinaturaPessoaObterPorIdTrancamento = 45,
  AssinaturaPessoaObterTodos = 46,
  AssinaturaPessoaObterTodosRecessos = 47,
  AssinaturaPessoaRemover = 48,
  AssinaturaPessoaRemoverComRecebimento = 271,
  AssinaturaPessoaRemoverTrancamento = 49,
  AssinaturaPessoaRenovar = 50,
  AssinaturaPessoaTrancamentoObterTodos = 51,
  AssinaturaRemover = 52,
  AtualizarCheque = 53,
  AutomacoesAdicionar = 54,
  AutomacoesAtualizar = 55,
  AutomacoesObterPorId = 56,
  AutomacoesObterTodos = 57,
  AutomacoesRemover = 58,
  AvaliacaoAdicionarAnamnese = 59,
  AvaliacaoAdicionarCapacidadeAerobicaVO2 = 60,
  AvaliacaoAdicionarComposicaoCorporalPerimetria = 61,
  AvaliacaoAdicionarFlexibilidade = 62,
  AvaliacaoAdicionarForcaResistenciaMuscular = 63,
  AvaliacaoAtualizarAnamnese = 64,
  AvaliacaoAtualizarComposicaoCorporalPerimetria = 65,
  AvaliacaoAtualizarFlexibilidade = 66,
  AvaliacaoAtualizarForcaResistenciaMuscular = 67,
  AvaliacaoObterPorId = 68,
  AvaliacaoObterTodos = 69,
  AvaliacaoRemover = 70,
  CaixaAbrir = 71,
  CaixaAuditar = 270,
  CaixaFechar = 72,
  CaixaLancamentoRetroativo = 73,
  CaixaObterTodos = 74,
  CancelarVendaAssinatura = 75,
  CancelarVendaAssinaturaAgrupadora = 76,
  CartoesRecebidos = 77,
  CategoriaAdicionar = 78,
  CategoriaAtualizar = 79,
  CategoriaObterPorId = 80,
  CategoriaRemover = 81,
  CategoriasObterTodos = 82,
  CedenteObterTodos = 83,
  ChequesRecebidos = 84,
  ClienteAdicionar = 85,
  ClienteAtualizar = 86,
  ClienteObterPorId = 87,
  ClienteObterTodos = 88,
  ClienteRemover = 89,
  ComissaoConsultores = 90,
  ComissaoProfessores = 91,
  CompraAdicionar = 92,
  CompraAtualizar = 93,
  CompraObterPorId = 94,
  CompraObterTodos = 95,
  CompraRemover = 96,
  CondicaoVendaProdutoAdicionar = 97,
  CondicaoVendaProdutoAtualizar = 98,
  CondicaoVendaProdutoObterPorId = 99,
  CondicaoVendaProdutoObterTodos = 100,
  CondicaoVendaProdutoRemover = 101,
  ContaBancariaAdicionar = 102,
  ContaBancariaAtualizar = 103,
  ContaBancariaObterPorId = 104,
  ContaBancariaObterTodos = 105,
  ContaBancariaRemover = 106,
  ContaPagarAdicionar = 107,
  ContaPagarAtualizar = 108,
  ContaPagarObterPorId = 109,
  ContaPagarObterTodos = 110,
  ContaPagarRemover = 111,
  ContaReceberAdicionar = 112,
  ContaReceberAtualizar = 113,
  ContaReceberObterPorId = 114,
  ContaReceberObterTodos = 115,
  ContaReceberReceber = 116,
  ContaReceberRemover = 117,
  ContatoAdicionar = 118,
  ContatoAtualizar = 119,
  ContatoObterPorId = 120,
  ContatoObterTodos = 121,
  ContatoRemover = 122,
  ContratoAdicionar = 123,
  ContratoAtualizar = 124,
  ContratoObterPorId = 125,
  ContratoObterTodos = 126,
  ContratoRemover = 127,
  ConvenioCartaoAdicionar = 128,
  ConvenioCartaoAtualizar = 129,
  ConvenioCartaoObterPorId = 130,
  ConvenioCartaoObterTodos = 131,
  ConvenioCartaoRemover = 132,
  CreditosClientesObterTodos = 133,
  DescontoAdicionar = 134,
  DescontoAtualizar = 135,
  DescontoObterPorId = 136,
  DescontoObterTodos = 137,
  DescontoRemover = 138,
  DocumentoAdicionar = 139,
  DocumentoAtualizar = 140,
  DocumentoObterPorId = 141,
  DocumentoObterTodos = 142,
  DocumentoRemover = 143,
  EncerrarAssinatura = 144,
  ExercicioAdicionar = 145,
  ExercicioAtualizar = 146,
  ExercicioObterPorId = 147,
  ExercicioObterTodos = 148,
  ExercicioRemover = 149,
  FaturaAtualizar = 150,
  FaturamentoPorPessoaId = 151,
  FaturaObterTodos = 152,
  FaturaRemover = 153,
  FichaAdicionar = 154,
  FichaAtualizar = 155,
  FichaObterPorId = 156,
  FichaObterTodos = 157,
  FichaRemover = 158,
  FornecedorAdicionar = 159,
  FornecedorAtualizar = 160,
  FornecedorObterPorId = 161,
  FornecedorObterTodos = 162,
  FornecedorRemover = 163,
  FuncoesAdicionar = 164,
  FuncoesAtualizar = 165,
  FuncoesObterPorId = 166,
  FuncoesObterTodos = 167,
  FuncoesRemover = 168,
  FunisAdicionar = 169,
  FunisAdicionarGatilho = 170,
  FunisAtualizar = 171,
  FunisObterPorId = 172,
  FunisObterTodos = 173,
  FunisRemover = 174,
  GetChatInfo = 175,
  LiberacaoAssinaturaPessoaAdicionar = 176,
  LiberacaoAssinaturaPessoaRemover = 177,
  ListarTodasApuracoes = 178,
  ListChats = 179,
  MultiploAgendamento = 180,
  NovoEncerramentoAssinaturaPessoa = 181,
  ObterAssinaturaPessoaEncerramentoPorId = 182,
  ObterAssinaturaPessoaRecessoPorId = 183,
  ObterChequePorId = 184,
  ObterPedidoVenda = 185,
  PagamentoAdicionar = 186,
  PagamentoAtualizar = 187,
  PagamentoEstornar = 188,
  PagamentoObterPorId = 189,
  PagamentoObterTodos = 190,
  PagamentoRemover = 191,
  PostagemAdicionar = 192,
  PostagemAtualizar = 193,
  PostagemObterPorId = 194,
  PostagemObterTodos = 195,
  PostagemRemover = 196,
  ProdutoAdicionar = 197,
  ProdutoAtualizar = 198,
  ProdutoObterPorId = 199,
  ProdutoObterTodos = 200,
  ProdutoRemover = 201,
  RecebimentoAtualizarJuros = 202,
  RecebimentoAtualizarMulta = 203,
  RecebimentoDescontoCadastrado = 204,
  RecebimentoDescontoManual = 205,
  RecebimentoEstornar = 206,
  RecebimentoObterTodos = 207,
  RemessaObterTodos = 208,
  RemoverAssinaturaPessoaRecesso = 209,
  RetornoAdicionar = 210,
  RetornoObterTodos = 211,
  ServicoAdicionar = 212,
  ServicoAtualizar = 213,
  ServicoObterPorId = 214,
  ServicoObterTodos = 215,
  ServicoPessoaAdicionar = 216,
  ServicoPessoaAtualizar = 217,
  ServicoPessoaObterPorId = 218,
  ServicoPessoaObterTodos = 219,
  ServicoPessoaRemover = 220,
  ServicoRemover = 221,
  TipoContaPagarAdicionar = 222,
  TipoContaPagarAtualizar = 223,
  TipoContaPagarObterPorId = 224,
  TipoContaPagarRemover = 225,
  TiposContaPagarObterTodos = 226,
  TreinoPreDefinidoAdicionar = 227,
  TreinoPreDefinidoAtualizar = 228,
  TreinoPreDefinidoObterPorId = 229,
  TreinoPreDefinidoObterTodos = 230,
  TreinoPreDefinidoRemover = 231,
  UsuarioAdicionar = 232,
  UsuarioAtualizar = 233,
  UsuarioObterPorId = 234,
  UsuarioObterTodos = 235,
  UsuarioRemover = 236,
  VendaAdicionar = 237,
  VendaAdicionarDesconto = 238,
  VendaAtualizar = 239,
  VendaObterPedido = 240,
  VendaObterPorId = 241,
  VendaObterTodos = 242,
  VendaRemover = 243,
  VisaoGeralAdministrador = 244,
  VisaoGeralImplatacao = 245,
  VisaoGeralSuporte = 246,
  VisaoGeralVendas = 247,
  VisitanteAdicionar = 248,
  VisitanteAtualizar = 249,
  VisitanteObterPorId = 250,
  VisitanteObterTodos = 251,
  VisitanteRemover = 252,
  DeckVisualizar = 253,
  DeckEditar = 254,
  ReceberDinheiro = 255,
  ReceberPix = 256,
  ReceberPagueLa = 257,
  ReceberCartao = 258,
  ReceberCheque = 259,
  ReceberCredito = 260,
  FaturaAlterarSituacao = 261,
  ModuloFinanceiroVisualizar = 262,
  FinanceiroPerfilVisualizar = 287,
  ClienteInativar = 263,
  AssinaturaPessoaAlterarSemRecebimento = 264,
  AssinaturaPessoaRemoverSemRecebimento = 265,
  VendaAlterarSemRecebimento = 266,
  VendaRemoverSemRecebimento = 267,
  ServicoAlterarSemRecebimento = 268,
  ServicoRemoverSemRecebimento = 269,
  DashboardAdministrativo = 272,
  DashboardResultados = 273,
  DashboardClientes = 274,
  DashboardAcesso = 275,
  DashboardContratos = 276,
  RecebimentoPersonalizado = 277,
  RelatorioVisualizarPessoas = 278,
  RelatorioVisualizarFinanceiro = 279,
  RelatorioVisualizarAssinaturas = 280,
  RelatorioVisualizarMercadorias = 281,
  RelatorioVisualizarServicos = 282,
  RelatorioVisualizarCRM = 283,
  RelatorioVisualizarTreino = 284,
  RelatorioVisualizarAfig = 285,
  RelatorioVisualizarAcessos = 286,
  NotaFiscalEmitir = 288,
  BoletoAlterarVencimento = 290,
    /** Grupo ClientesEVisitantes — "Gerenciar negativação do cliente". Nasce desligada. */
  ClienteNegativacaoGerenciar = 291,
  /** Grupo Financeiro — "Cancelar e reativar parcelas". Nasce desligada. */
  ContaReceberCancelarReativarParcela = 292,
  /** Grupo Financeiro — "Renegociar contas a receber". Nasce desligada. */
  ContaReceberRenegociar = 293,
  LancarAssinaturaLote = 295,
  EncerrarAssinaturaLote = 296,
  FrequenciaVisualizar = 297,
  FrequenciaMarcarExcecao = 298,
  FrequenciaFinalizar = 299,
  FrequenciaCorrigir = 300,
  FrequenciaConfigurar = 301,
  JustificativaVisualizar = 302,
  JustificativaRegistrar = 303,
  JustificativaDecidir = 304,
  /** Ends a plan that has a paid balance. Backfilled into existing roles (spec 003, FR-080). */
  EncerrarAssinaturaComSaldo = 305,
  /** Edits the automatic inactivation rules. Off by default. */
  RegrasInativacaoAlterar = 306,
  /** Opens Settings › Audit. Off by default. */
  AuditoriaVisualizar = 307,
  /** Opens "My subscription" (the gym's own Actuar plan). Off by default. */
  MinhaAssinaturaVisualizar = 308,
  /** People group — opens People › Inactives. Off by default (spec 004, D9). */
  InativosVisualizar = 309,
  VerRedeResultados = 310,
  VerRedeClientes = 311,
  VerRedeAcesso = 312,
  VerRedeContratos = 313,
  RedeVerUsuarios = 314,
  RedeAtribuirPermissoes = 315,
  RedeRemoverPermissoes = 316,
  /**
   * Group Atendimento (`GroupsEnum.Atendimento = 22`, Actuar.Auth 10.88.1): the support console.
   * Every one is born off, the default Administrator role included, and the production catalog
   * only lists them once the userservice ships that package (devolutiva 18, item 148).
   */
  AtendimentoAcessar = 325,
  AtendimentoAtender = 326,
  AtendimentoGerirConversasDaEquipe = 327,
  AtendimentoRelatoriosVisualizar = 328,
  AtendimentoRelatoriosDaEquipeVisualizar = 329,
  AtendimentoAgentesEquipesGerir = 330,
  AtendimentoContatoEditar = 331,
  AtendimentoContatoBloquear = 332,
  AtendimentoConfigurar = 333,
  /** Grants a commercial exception on a subscription, e.g. the negotiated plan floor lock (043). */
  LiberarExcecaoComercial = 334,

}

export enum PermissionText {
  AcaoPorPessoaDisparar = 'AcaoPorPessoaDisparar',
  AcessosObterTodos = 'AcessosObterTodos',
  AcoesAdicionar = 'AcoesAdicionar',
  AcoesAdicionarAcoesPessoas = 'AcoesAdicionarAcoesPessoas',
  AcoesAdicionarCometarios = 'AcoesAdicionarCometarios',
  AcoesAtualizar = 'AcoesAtualizar',
  AcoesAtualizarEtapas = 'AcoesAtualizarEtapas',
  AcoesDetalhamentosObterTodos = 'AcoesDetalhamentosObterTodos',
  AcoesObterDetalhamentoPorId = 'AcoesObterDetalhamentoPorId',
  AcoesObterPorId = 'AcoesObterPorId',
  AcoesObterTodos = 'AcoesObterTodos',
  AcoesRemoverPorPessoaId = 'AcoesRemoverPorPessoaId',
  AdicionarAssinaturaPessoaTransferencia = 'AdicionarAssinaturaPessoaTransferencia',
  AjusteAtualizar = 'AjusteAtualizar',
  AjusteEstoqueProdutoAdicionar = 'AjusteEstoqueProdutoAdicionar',
  AjusteEstoqueProdutoAtualizar = 'AjusteEstoqueProdutoAtualizar',
  AjusteEstoqueProdutoObterPorId = 'AjusteEstoqueProdutoObterPorId',
  AjusteEstoqueProdutoObterTodos = 'AjusteEstoqueProdutoObterTodos',
  AjusteEstoqueProdutoRemover = 'AjusteEstoqueProdutoRemover',
  AssinaturaAdicionar = 'AssinaturaAdicionar',
  AssinaturaAgrupadoraAdicionar = 'AssinaturaAgrupadoraAdicionar',
  AssinaturaAgrupadoraAtualizar = 'AssinaturaAgrupadoraAtualizar',
  AssinaturaAgrupadoraObterPorId = 'AssinaturaAgrupadoraObterPorId',
  AssinaturaAgrupadoraRemover = 'AssinaturaAgrupadoraRemover',
  AssinaturaAtualizar = 'AssinaturaAtualizar',
  AssinaturaHorarioAdicionar = 'AssinaturaHorarioAdicionar',
  AssinaturaHorarioAtualizar = 'AssinaturaHorarioAtualizar',
  AssinaturaHorarioObterPorId = 'AssinaturaHorarioObterPorId',
  AssinaturaHorarioObterTodos = 'AssinaturaHorarioObterTodos',
  AssinaturaHorarioRemover = 'AssinaturaHorarioRemover',
  AssinaturaObterPorId = 'AssinaturaObterPorId',
  AssinaturaObterTodos = 'AssinaturaObterTodos',
  AssinaturaOcupacaoObterTodos = 'AssinaturaOcupacaoObterTodos',
  AssinaturaPessoaAdicionar = 'AssinaturaPessoaAdicionar',
  AssinaturaPessoaAdicionarRecesso = 'AssinaturaPessoaAdicionarRecesso',
  AssinaturaPessoaAdicionarRecessoColetivo = 'AssinaturaPessoaAdicionarRecessoColetivo',
  AssinaturaPessoaAdicionarTrancamento = 'AssinaturaPessoaAdicionarTrancamento',
  AssinaturaPessoaAlterar = 'AssinaturaPessoaAlterar',
  AssinaturaPessoaAtualizar = 'AssinaturaPessoaAtualizar',
  AssinaturaPessoaEditarRecesso = 'AssinaturaPessoaEditarRecesso',
  AssinaturaPessoaEditarTrancamento = 'AssinaturaPessoaEditarTrancamento',
  AssinaturaPessoaEncerramentoObterTodos = 'AssinaturaPessoaEncerramentoObterTodos',
  AssinaturaPessoaFrequenciaObterTodos = 'AssinaturaPessoaFrequenciaObterTodos',
  AssinaturaPessoaObterPorId = 'AssinaturaPessoaObterPorId',
  AssinaturaPessoaObterPorIdTrancamento = 'AssinaturaPessoaObterPorIdTrancamento',
  AssinaturaPessoaObterTodos = 'AssinaturaPessoaObterTodos',
  AssinaturaPessoaObterTodosRecessos = 'AssinaturaPessoaObterTodosRecessos',
  AssinaturaPessoaRemover = 'AssinaturaPessoaRemover',
  AssinaturaPessoaRemoverComRecebimento = 'AssinaturaPessoaRemoverComRecebimento',
  AssinaturaPessoaRemoverTrancamento = 'AssinaturaPessoaRemoverTrancamento',
  AssinaturaPessoaRenovar = 'AssinaturaPessoaRenovar',
  AssinaturaPessoaTrancamentoObterTodos = 'AssinaturaPessoaTrancamentoObterTodos',
  AssinaturaRemover = 'AssinaturaRemover',
  AtualizarCheque = 'AtualizarCheque',
  AutomacoesAdicionar = 'AutomacoesAdicionar',
  AutomacoesAtualizar = 'AutomacoesAtualizar',
  AutomacoesObterPorId = 'AutomacoesObterPorId',
  AutomacoesObterTodos = 'AutomacoesObterTodos',
  AutomacoesRemover = 'AutomacoesRemover',
  AvaliacaoAdicionarAnamnese = 'AvaliacaoAdicionarAnamnese',
  AvaliacaoAdicionarCapacidadeAerobicaVO2 = 'AvaliacaoAdicionarCapacidadeAerobicaVO2',
  AvaliacaoAdicionarComposicaoCorporalPerimetria = 'AvaliacaoAdicionarComposicaoCorporalPerimetria',
  AvaliacaoAdicionarFlexibilidade = 'AvaliacaoAdicionarFlexibilidade',
  AvaliacaoAdicionarForcaResistenciaMuscular = 'AvaliacaoAdicionarForcaResistenciaMuscular',
  AvaliacaoAtualizarAnamnese = 'AvaliacaoAtualizarAnamnese',
  AvaliacaoAtualizarComposicaoCorporalPerimetria = 'AvaliacaoAtualizarComposicaoCorporalPerimetria',
  AvaliacaoAtualizarFlexibilidade = 'AvaliacaoAtualizarFlexibilidade',
  AvaliacaoAtualizarForcaResistenciaMuscular = 'AvaliacaoAtualizarForcaResistenciaMuscular',
  AvaliacaoObterPorId = 'AvaliacaoObterPorId',
  AvaliacaoObterTodos = 'AvaliacaoObterTodos',
  AvaliacaoRemover = 'AvaliacaoRemover',
  CaixaAbrir = 'CaixaAbrir',
  CaixaAuditar = 'CaixaAuditar',
  CaixaFechar = 'CaixaFechar',
  CaixaLancamentoRetroativo = 'CaixaLancamentoRetroativo',
  CaixaObterTodos = 'CaixaObterTodos',
  CancelarVendaAssinatura = 'CancelarVendaAssinatura',
  CancelarVendaAssinaturaAgrupadora = 'CancelarVendaAssinaturaAgrupadora',
  CartoesRecebidos = 'CartoesRecebidos',
  CategoriaAdicionar = 'CategoriaAdicionar',
  CategoriaAtualizar = 'CategoriaAtualizar',
  CategoriaObterPorId = 'CategoriaObterPorId',
  CategoriaRemover = 'CategoriaRemover',
  CategoriasObterTodos = 'CategoriasObterTodos',
  CedenteObterTodos = 'CedenteObterTodos',
  ChequesRecebidos = 'ChequesRecebidos',
  ClienteAdicionar = 'ClienteAdicionar',
  ClienteAtualizar = 'ClienteAtualizar',
  ClienteNegativacaoGerenciar = 'ClienteNegativacaoGerenciar',
  ClienteObterPorId = 'ClienteObterPorId',
  ClienteObterTodos = 'ClienteObterTodos',
  ClienteRemover = 'ClienteRemover',
  ComissaoConsultores = 'ComissaoConsultores',
  ComissaoProfessores = 'ComissaoProfessores',
  CompraAdicionar = 'CompraAdicionar',
  CompraAtualizar = 'CompraAtualizar',
  CompraObterPorId = 'CompraObterPorId',
  CompraObterTodos = 'CompraObterTodos',
  CompraRemover = 'CompraRemover',
  CondicaoVendaProdutoAdicionar = 'CondicaoVendaProdutoAdicionar',
  CondicaoVendaProdutoAtualizar = 'CondicaoVendaProdutoAtualizar',
  CondicaoVendaProdutoObterPorId = 'CondicaoVendaProdutoObterPorId',
  CondicaoVendaProdutoObterTodos = 'CondicaoVendaProdutoObterTodos',
  CondicaoVendaProdutoRemover = 'CondicaoVendaProdutoRemover',
  ContaBancariaAdicionar = 'ContaBancariaAdicionar',
  ContaBancariaAtualizar = 'ContaBancariaAtualizar',
  ContaBancariaObterPorId = 'ContaBancariaObterPorId',
  ContaBancariaObterTodos = 'ContaBancariaObterTodos',
  ContaBancariaRemover = 'ContaBancariaRemover',
  ContaPagarAdicionar = 'ContaPagarAdicionar',
  ContaPagarAtualizar = 'ContaPagarAtualizar',
  ContaPagarObterPorId = 'ContaPagarObterPorId',
  ContaPagarObterTodos = 'ContaPagarObterTodos',
  ContaPagarRemover = 'ContaPagarRemover',
  ContaReceberAdicionar = 'ContaReceberAdicionar',
  ContaReceberAtualizar = 'ContaReceberAtualizar',
  ContaReceberObterPorId = 'ContaReceberObterPorId',
  ContaReceberObterTodos = 'ContaReceberObterTodos',
  ContaReceberReceber = 'ContaReceberReceber',
  ContaReceberRemover = 'ContaReceberRemover',
  ContatoAdicionar = 'ContatoAdicionar',
  ContatoAtualizar = 'ContatoAtualizar',
  ContatoObterPorId = 'ContatoObterPorId',
  ContatoObterTodos = 'ContatoObterTodos',
  ContatoRemover = 'ContatoRemover',
  ContratoAdicionar = 'ContratoAdicionar',
  ContratoAtualizar = 'ContratoAtualizar',
  ContratoObterPorId = 'ContratoObterPorId',
  ContratoObterTodos = 'ContratoObterTodos',
  ContratoRemover = 'ContratoRemover',
  ConvenioCartaoAdicionar = 'ConvenioCartaoAdicionar',
  ConvenioCartaoAtualizar = 'ConvenioCartaoAtualizar',
  ConvenioCartaoObterPorId = 'ConvenioCartaoObterPorId',
  ConvenioCartaoObterTodos = 'ConvenioCartaoObterTodos',
  ConvenioCartaoRemover = 'ConvenioCartaoRemover',
  CreditosClientesObterTodos = 'CreditosClientesObterTodos',
  DescontoAdicionar = 'DescontoAdicionar',
  DescontoAtualizar = 'DescontoAtualizar',
  DescontoObterPorId = 'DescontoObterPorId',
  DescontoObterTodos = 'DescontoObterTodos',
  DescontoRemover = 'DescontoRemover',
  DocumentoAdicionar = 'DocumentoAdicionar',
  DocumentoAtualizar = 'DocumentoAtualizar',
  DocumentoObterPorId = 'DocumentoObterPorId',
  DocumentoObterTodos = 'DocumentoObterTodos',
  DocumentoRemover = 'DocumentoRemover',
  EncerrarAssinatura = 'EncerrarAssinatura',
  ExercicioAdicionar = 'ExercicioAdicionar',
  ExercicioAtualizar = 'ExercicioAtualizar',
  ExercicioObterPorId = 'ExercicioObterPorId',
  ExercicioObterTodos = 'ExercicioObterTodos',
  ExercicioRemover = 'ExercicioRemover',
  FaturaAtualizar = 'FaturaAtualizar',
  FaturamentoPorPessoaId = 'FaturamentoPorPessoaId',
  FaturaObterTodos = 'FaturaObterTodos',
  FaturaRemover = 'FaturaRemover',
  FichaAdicionar = 'FichaAdicionar',
  FichaAtualizar = 'FichaAtualizar',
  FichaObterPorId = 'FichaObterPorId',
  FichaObterTodos = 'FichaObterTodos',
  FichaRemover = 'FichaRemover',
  FornecedorAdicionar = 'FornecedorAdicionar',
  FornecedorAtualizar = 'FornecedorAtualizar',
  FornecedorObterPorId = 'FornecedorObterPorId',
  FornecedorObterTodos = 'FornecedorObterTodos',
  FornecedorRemover = 'FornecedorRemover',
  FuncoesAdicionar = 'FuncoesAdicionar',
  FuncoesAtualizar = 'FuncoesAtualizar',
  FuncoesObterPorId = 'FuncoesObterPorId',
  FuncoesObterTodos = 'FuncoesObterTodos',
  FuncoesRemover = 'FuncoesRemover',
  FunisAdicionar = 'FunisAdicionar',
  FunisAdicionarGatilho = 'FunisAdicionarGatilho',
  FunisAtualizar = 'FunisAtualizar',
  FunisObterPorId = 'FunisObterPorId',
  FunisObterTodos = 'FunisObterTodos',
  FunisRemover = 'FunisRemover',
  GetChatInfo = 'GetChatInfo',
  LiberacaoAssinaturaPessoaAdicionar = 'LiberacaoAssinaturaPessoaAdicionar',
  LiberacaoAssinaturaPessoaRemover = 'LiberacaoAssinaturaPessoaRemover',
  ListarTodasApuracoes = 'ListarTodasApuracoes',
  ListChats = 'ListChats',
  MultiploAgendamento = 'MultiploAgendamento',
  NotaFiscalEmitir = 'NotaFiscalEmitir',
  NovoEncerramentoAssinaturaPessoa = 'NovoEncerramentoAssinaturaPessoa',
  ObterAssinaturaPessoaEncerramentoPorId = 'ObterAssinaturaPessoaEncerramentoPorId',
  ObterAssinaturaPessoaRecessoPorId = 'ObterAssinaturaPessoaRecessoPorId',
  ObterChequePorId = 'ObterChequePorId',
  ObterPedidoVenda = 'ObterPedidoVenda',
  PagamentoAdicionar = 'PagamentoAdicionar',
  PagamentoAtualizar = 'PagamentoAtualizar',
  PagamentoEstornar = 'PagamentoEstornar',
  PagamentoObterPorId = 'PagamentoObterPorId',
  PagamentoObterTodos = 'PagamentoObterTodos',
  PagamentoRemover = 'PagamentoRemover',
  PostagemAdicionar = 'PostagemAdicionar',
  PostagemAtualizar = 'PostagemAtualizar',
  PostagemObterPorId = 'PostagemObterPorId',
  PostagemObterTodos = 'PostagemObterTodos',
  PostagemRemover = 'PostagemRemover',
  ProdutoAdicionar = 'ProdutoAdicionar',
  ProdutoAtualizar = 'ProdutoAtualizar',
  ProdutoObterPorId = 'ProdutoObterPorId',
  ProdutoObterTodos = 'ProdutoObterTodos',
  ProdutoRemover = 'ProdutoRemover',
  RecebimentoAtualizarJuros = 'RecebimentoAtualizarJuros',
  RecebimentoAtualizarMulta = 'RecebimentoAtualizarMulta',
  RecebimentoDescontoCadastrado = 'RecebimentoDescontoCadastrado',
  RecebimentoDescontoManual = 'RecebimentoDescontoManual',
  RecebimentoEstornar = 'RecebimentoEstornar',
  RecebimentoObterTodos = 'RecebimentoObterTodos',
  RemessaObterTodos = 'RemessaObterTodos',
  RemoverAssinaturaPessoaRecesso = 'RemoverAssinaturaPessoaRecesso',
  RetornoAdicionar = 'RetornoAdicionar',
  RetornoObterTodos = 'RetornoObterTodos',
  ServicoAdicionar = 'ServicoAdicionar',
  ServicoAtualizar = 'ServicoAtualizar',
  ServicoObterPorId = 'ServicoObterPorId',
  ServicoObterTodos = 'ServicoObterTodos',
  ServicoPessoaAdicionar = 'ServicoPessoaAdicionar',
  ServicoPessoaAtualizar = 'ServicoPessoaAtualizar',
  ServicoPessoaObterPorId = 'ServicoPessoaObterPorId',
  ServicoPessoaObterTodos = 'ServicoPessoaObterTodos',
  ServicoPessoaRemover = 'ServicoPessoaRemover',
  ServicoRemover = 'ServicoRemover',
  TipoContaPagarAdicionar = 'TipoContaPagarAdicionar',
  TipoContaPagarAtualizar = 'TipoContaPagarAtualizar',
  TipoContaPagarObterPorId = 'TipoContaPagarObterPorId',
  TipoContaPagarRemover = 'TipoContaPagarRemover',
  TiposContaPagarObterTodos = 'TiposContaPagarObterTodos',
  TreinoPreDefinidoAdicionar = 'TreinoPreDefinidoAdicionar',
  TreinoPreDefinidoAtualizar = 'TreinoPreDefinidoAtualizar',
  TreinoPreDefinidoObterPorId = 'TreinoPreDefinidoObterPorId',
  TreinoPreDefinidoObterTodos = 'TreinoPreDefinidoObterTodos',
  TreinoPreDefinidoRemover = 'TreinoPreDefinidoRemover',
  UsuarioAdicionar = 'UsuarioAdicionar',
  UsuarioAtualizar = 'UsuarioAtualizar',
  UsuarioObterPorId = 'UsuarioObterPorId',
  UsuarioObterTodos = 'UsuarioObterTodos',
  UsuarioRemover = 'UsuarioRemover',
  VendaAdicionar = 'VendaAdicionar',
  VendaAdicionarDesconto = 'VendaAdicionarDesconto',
  VendaAtualizar = 'VendaAtualizar',
  VendaObterPedido = 'VendaObterPedido',
  VendaObterPorId = 'VendaObterPorId',
  VendaObterTodos = 'VendaObterTodos',
  VendaRemover = 'VendaRemover',
  VisaoGeralAdministrador = 'VisaoGeralAdministrador',
  VisaoGeralImplatacao = 'VisaoGeralImplatacao',
  VisaoGeralSuporte = 'VisaoGeralSuporte',
  VisaoGeralVendas = 'VisaoGeralVendas',
  VisitanteAdicionar = 'VisitanteAdicionar',
  VisitanteAtualizar = 'VisitanteAtualizar',
  VisitanteObterPorId = 'VisitanteObterPorId',
  VisitanteObterTodos = 'VisitanteObterTodos',
  VisitanteRemover = 'VisitanteRemover',
  DeckVisualizar = 'DeckVisualizar',
  DeckEditar = 'DeckEditar',
  ReceberDinheiro = 'ReceberDinheiro',
  ReceberPix = 'ReceberPix',
  ReceberPagueLa = 'ReceberPagueLa',
  ReceberCartao = 'ReceberCartao',
  ReceberCheque = 'ReceberCheque',
  ReceberCredito = 'ReceberCredito',
  FaturaAlterarSituacao = 'FaturaAlterarSituacao',
  ModuloFinanceiroVisualizar = 'ModuloFinanceiroVisualizar',
  FinanceiroPerfilVisualizar = 'FinanceiroPerfilVisualizar',
  ClienteInativar = 'ClienteInativar',
  AssinaturaPessoaAlterarSemRecebimento = 'AssinaturaPessoaAlterarSemRecebimento',
  AssinaturaPessoaRemoverSemRecebimento = 'AssinaturaPessoaRemoverSemRecebimento',
  VendaAlterarSemRecebimento = 'VendaAlterarSemRecebimento',
  VendaRemoverSemRecebimento = 'VendaRemoverSemRecebimento',
  ServicoAlterarSemRecebimento = 'ServicoAlterarSemRecebimento',
  ServicoRemoverSemRecebimento = 'ServicoRemoverSemRecebimento',
  DashboardAdministrativo = 'DashboardAdministrativo',
  DashboardResultados = 'DashboardResultados',
  DashboardClientes = 'DashboardClientes',
  DashboardAcesso = 'DashboardAcesso',
  DashboardContratos = 'DashboardContratos',
  RecebimentoPersonalizado = 'RecebimentoPersonalizado',
  RelatorioVisualizarPessoas = 'RelatorioVisualizarPessoas',
  RelatorioVisualizarFinanceiro = 'RelatorioVisualizarFinanceiro',
  RelatorioVisualizarAssinaturas = 'RelatorioVisualizarAssinaturas',
  RelatorioVisualizarMercadorias = 'RelatorioVisualizarMercadorias',
  RelatorioVisualizarServicos = 'RelatorioVisualizarServicos',
  RelatorioVisualizarCRM = 'RelatorioVisualizarCRM',
  RelatorioVisualizarTreino = 'RelatorioVisualizarTreino',
  RelatorioVisualizarAfig = 'RelatorioVisualizarAfig',
  RelatorioVisualizarAcessos = 'RelatorioVisualizarAcessos',
  BoletoAlterarVencimento = 'BoletoAlterarVencimento',
  LancarAssinaturaLote = 'LancarAssinaturaLote',
  EncerrarAssinaturaLote = 'EncerrarAssinaturaLote',
  ContaReceberCancelarReativarParcela = 'ContaReceberCancelarReativarParcela',
  ContaReceberRenegociar = 'ContaReceberRenegociar',
  FrequenciaVisualizar = 'FrequenciaVisualizar',
  FrequenciaMarcarExcecao = 'FrequenciaMarcarExcecao',
  FrequenciaFinalizar = 'FrequenciaFinalizar',
  FrequenciaCorrigir = 'FrequenciaCorrigir',
  FrequenciaConfigurar = 'FrequenciaConfigurar',
  JustificativaVisualizar = 'JustificativaVisualizar',
  JustificativaRegistrar = 'JustificativaRegistrar',
  JustificativaDecidir = 'JustificativaDecidir',
  EncerrarAssinaturaComSaldo = 'EncerrarAssinaturaComSaldo',
  RegrasInativacaoAlterar = 'RegrasInativacaoAlterar',
  AuditoriaVisualizar = 'AuditoriaVisualizar',
  MinhaAssinaturaVisualizar = 'MinhaAssinaturaVisualizar',
  InativosVisualizar = 'InativosVisualizar',
  VerRedeResultados = 'VerRedeResultados',
  VerRedeClientes = 'VerRedeClientes',
  VerRedeAcesso = 'VerRedeAcesso',
  VerRedeContratos = 'VerRedeContratos',
  RedeVerUsuarios = 'RedeVerUsuarios',
  RedeAtribuirPermissoes = 'RedeAtribuirPermissoes',
  RedeRemoverPermissoes = 'RedeRemoverPermissoes',
  AtendimentoAcessar = 'AtendimentoAcessar',
  AtendimentoAtender = 'AtendimentoAtender',
  AtendimentoGerirConversasDaEquipe = 'AtendimentoGerirConversasDaEquipe',
  AtendimentoRelatoriosVisualizar = 'AtendimentoRelatoriosVisualizar',
  AtendimentoRelatoriosDaEquipeVisualizar = 'AtendimentoRelatoriosDaEquipeVisualizar',
  AtendimentoAgentesEquipesGerir = 'AtendimentoAgentesEquipesGerir',
  AtendimentoContatoEditar = 'AtendimentoContatoEditar',
  AtendimentoContatoBloquear = 'AtendimentoContatoBloquear',
  AtendimentoConfigurar = 'AtendimentoConfigurar',
  LiberarExcecaoComercial = 'LiberarExcecaoComercial',
}
